// extracted by mini-css-extract-plugin
export default {"form":"XflUuB9wv4NKYdyH2tJf","legalCopy":"xyfNgIjduV09HRg3fX7O"};